import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import ContentProvider from '../../components/ContentProvider';
import AboutPage from './AboutPage';
import PrivacyPage from './PrivacyPage';
import TermsPage from './TermsPage';
import ReviewPage from './ReviewPage';
import ProvidersPage from './ProvidersPage';
import ContactPage from './ContactPage';
import ContentPage from './ContentPage';  // default CMS content page
import ServiceRedirect from './ServiceRedirect';
import ServiceCategoriesPage from './ServiceCategoriesPage';
import config from '../../config';

// returns a render function for a component with a ContentProvider wrapper
const wrapped = (Component) => (props) => <ContentProvider component={Component} {...props}/>;
const ExternalRedirect = ({to}) => {window.location.href = to; return null;};

const routes = () => {
  return [
    <Route key="/about" path="/about" render={wrapped(AboutPage)}/>,
    <Route key="/faq" path="/faq" render={() => <ExternalRedirect to={config.link.faq}/>}/>,
    <Route key="/privacy" path="/privacy" render={wrapped(PrivacyPage)}/>,
    <Route key="/how-to-write-a-review" path="/how-to-write-a-review" render={() => <Redirect to="/review/"/>}/>,
    <Route key="/why-subscribe" path="/why-subscribe" render={() => <Redirect to="/about-accreditation/"/>}/>,
    <Route key="/about-accreditation" path="/about-accreditation" render={wrapped(ContentPage)}/>,
    <Route key="/terms" path="/terms" render={wrapped(TermsPage)}/>,
    <Route key="/providers/faq" exact={true} path="/providers/faq" render={() => <ExternalRedirect to={config.link.providerFaq}/>}/>,
    <Route key="/provider-faq" path="/provider-faq" render={() => <ExternalRedirect to={config.link.providerFaq}/>}/>,
    <Route key="/providers" exact={true} path="/providers" render={wrapped(ProvidersPage)}/>,
    <Route key="/contact" path="/contact" render={wrapped(ContactPage)}/>,
    <Route key="/team" path="/team" render={() => <Redirect to="/about/"/>}/>,
    <Route key="add-a-listing" path="/add-a-listing" render={() => <Redirect to="/providers/signup"/>}/>,
    <Route key="/review" path="/review" render={wrapped(ReviewPage)}/>,
    <Route key="/categories-explained" path="/categories-explained" render={() => <ExternalRedirect to={config.link.faq}/>}/>,
    <Route key="/blog-guidelines" path="/blog-guidelines" render={wrapped(ContentPage)}/>,
    <Route key="/content-guidelines" path="/content-guidelines" render={wrapped(ContentPage)}/>,
    <Route key="/service" path="/service/:slug" exact={false} render={ServiceRedirect}/>,
    <Route key="/servicecategories" path="/servicecategories" component={ServiceCategoriesPage}/>,
  ];
};

export default routes;
